import { Directive, ElementRef, HostListener, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
  selector: '[thehubzTagsChipAutoWidth]',
  standalone: true,
})
export class TagsChipAutoWidthDirective implements OnDestroy {
  private hiddenSpan: HTMLSpanElement;

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private renderer: Renderer2,
  ) {
    this.hiddenSpan = this.renderer.createElement('span');
    this.renderer.addClass(this.hiddenSpan, 'resizable-input');
    document.body.appendChild(this.hiddenSpan);
  }

  @HostListener('input') onInput() {
    this.resize();
  }

  @HostListener('focus') onFocus() {
    this.resize();
  }

  private resize() {
    const input = this.el.nativeElement;

    const { font, letterSpacing, padding } = window.getComputedStyle(input);
    this.hiddenSpan.style.font = font;
    this.hiddenSpan.style.letterSpacing = letterSpacing;
    this.hiddenSpan.style.padding = padding;

    this.hiddenSpan.textContent = input.value || input.placeholder || '';

    const textWidth = this.hiddenSpan.offsetWidth;

    const newWidth = textWidth + 40;
    this.renderer.setStyle(input, 'width', `${newWidth}px`);
  }

  ngOnDestroy() {
    if (this.hiddenSpan && this.hiddenSpan.parentNode) {
      this.renderer.removeChild(document.body, this.hiddenSpan);
    }
  }
}
